import sigliveServiceV2 from 'Service/sigliveServiceV2';

const getRoleAccess = async () => {
  const { data } = await sigliveServiceV2({ method: 'GET', url: `/access/list-menu` });

  return data?.data;
};

export default getRoleAccess;
